import React, { useEffect, useState, useRef } from "react";
import TextBox from "../Common/TextBox";
import ErrorIcon from "../../Icons/NotificationMessage/Info";
import SuccessIcon from "../../Icons/NotificationMessage/Success";
import LoadingIcon from "../Settings/Storage/StorageCalibration/AutoCalibration/RollerLoadingAnimation";
import "./InputField.css";

export enum EInputState {
  Undefined,
  Success,
  Error,
  Loading,
}

type Props = {
  name: string;
  value: string | number;
  onChange?: (value: string | number) => void;
  onClick?: () => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  className?: string;
  isInteger?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  variant:  "text" | "number" | "password";
  placeHolder?: string;
  decimalPoint?: number;
  onErrorOccured?: (key: string) => void;
  onErrorCleared?: (key: string) => void;
  errorMessage?: string;
  inputState?: EInputState;
};
export function InputField({
  name,
  value,
  onChange = () => {},
  onClick = () => {},
  onKeyPress = () => {},
  onKeyDown = () => {},
  className = "",
  disabled = false,
  readOnly = false,
  variant = "text",
  placeHolder,
  onErrorOccured = () => {},
  onErrorCleared = () => {},
  errorMessage = "",
  inputState = EInputState.Undefined,
}: Props) {
  return (
    <div className="input-field-container">
      <span className="input-field-label">{name}</span>
      <div className="input-field-text">
        <TextBox
          name={name}
          value={value}
          onChange={readOnly ? () => {} : (e) => onChange(e)}
          onClick={onClick}
          variant={variant}
          className={className}
          disabled={disabled}
          readOnly={readOnly}
          placeHolder={placeHolder}
          style={{
            border: "solid",
            boxSizing: "border-box",
            borderRadius: "2px",
            width: "100%",
            height: 38,
            borderColor:
              inputState == EInputState.Error ? "#C92932" : "#B4B4B4",
          }}
        />
      </div>

      {inputState == EInputState.Error && errorMessage != "" && (
        <div className="input-field-error-message">
          <ErrorIcon fill="#C92932" width="10" height="10" />
          <p>{errorMessage}</p>
        </div>
      )}

      <div className="input-field-icon">
        {inputState == EInputState.Error && (
          <div>
            <ErrorIcon fill="#C92932" width="29px" height="29px" />
          </div>
        )}
        {inputState == EInputState.Success && (
          <div>
            <SuccessIcon fill="#C92932" width="29px" height="29px" />
          </div>
        )}
        {inputState == EInputState.Loading && (
          <LoadingIcon
            style={{
              width: "29px",
              height: "29px",
              transform: "translate(-50%, -50%) scale(0.5)",
            }}
          />
        )}
      </div>
    </div>
  );
}
